// extracted by mini-css-extract-plugin
export default {"bottom":"scoreCardThresholds__bottom___gTyfo","sectionsHeading":"scoreCardThresholds__sectionsHeading___lMwQ+","firstCell":"scoreCardThresholds__firstCell___7rWfp"};